import React, { useState } from 'react';
import { CopyIcon } from '../svgs/ExpressonSVGs';

type CopyToClipboardProps = {
	text: string;
}
/**
 * CopyToClipboard component
 * 
 * Renders a copy icon that copies the provided text to clipboard when clicked
 * Shows a temporary notice when text is copied
 * 
 * @param text 
 * @returns 
 */
const CopyToClipboard: React.FC<CopyToClipboardProps> = ({ text }) => {
	const [showNotice, setShowNotice] = useState(false);

	const handleCopy = () => {
		navigator.clipboard.writeText(text);
		
		// Show the notice
		setShowNotice(true);
		
		// Remove the notice after 4 seconds
		setTimeout(() => {
			setShowNotice(false);
		}, 4000);
	};

	return (
		<div 
			className={`copy-to-clipboard ${showNotice ? 'show-notice' : ''}`}
			onClick={handleCopy}
			tabIndex={0}
			onKeyDown={(e) => {
				if (e.key === 'Enter' || e.key === ' ') {
					handleCopy();
				}
			}}
			aria-label="Kopiera till urklipp"
			role="button"
		>
			<CopyIcon width="22" height="22" />
		</div>
	)
}

export default CopyToClipboard;